import { Component, OnInit } from '@angular/core';
import { TerceroService } from '../../../service/tercero.service';
import { GrupoMenu } from '../../../domain/grupo-menu';
import { MenuService } from '../../../service/menu.service';
import { AuthService } from '../../../service/auth/auth.service';
import { NovedadService } from '../../../service/novedad.service';
import { GenericResponse } from '../../../domain/genericResponse';
import { GLOBAL } from '../../../global';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent{

  public novedadesSinLeer: number;

  constructor(private menuService: MenuService,
    public novedadService: NovedadService) {
  }

  openMegaMenu() {
    let pane = document.getElementsByClassName('cdk-overlay-pane');
    [].forEach.call(pane, function (el) {
      if (el.children.length > 0) {
        if (el.children[0].classList.contains('mega-menu')) {
          el.classList.add('mega-menu-pane');
        }
      }
    });
  }

  getOpciones() : Array<GrupoMenu> {
    return this.menuService.menu;
  }
}
